import React from 'react';

function Print() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="19"
      viewBox="0 0 21 19"
    >
      <path
        fill="#505050"
        fillRule="evenodd"
        d="M18 1.357v1.357H3V1.357C3 .608 3.672 0 4.5 0h12c.828 0 1.5.608 1.5 1.357zm1.5 2.714c.828 0 1.5.608 1.5 1.358v8.142c0 .75-.672 1.358-1.5 1.358H18v2.714c0 .749-.672 1.357-1.5 1.357h-12c-.828 0-1.5-.608-1.5-1.357v-2.714H1.5c-.828 0-1.5-.608-1.5-1.358V5.43c0-.75.672-1.358 1.5-1.358h18zm-3 13.572v-6.786h-12v6.786h12zm1.5-9.5V6.786h-3v1.357h3zM6 14.929h4.5v1.357H6v-1.357zm0-2.715h9v1.357H6v-1.357z"
      />
    </svg>
  );
}

export default Print;
